module.exports = __webpack_public_path__ + "static/pakmaya-case-study-76b5dd8aaf16b74686d411d830300e5a.webp";